import { createElement } from "react";
import React from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { hierarchyContext } from "../../CompanyHierarchyContext.js";
import { map, find, choose, partition } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { useEffectWithDeps } from "../../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { generateQueryString } from "../../Shared/Urls.js";
import { createObj, uncurry2, int32ToString } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { toString } from "../../fable_modules/fable-library-js.4.24.0/Types.js";
import { join } from "../../fable_modules/fable-library-js.4.24.0/String.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Tickets_TicketMeta_$reflection } from "../../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { some, unwrap, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString as toString_1 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createDisposable } from "../../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { Components_CriticalTicketsTable_334C27A3 } from "../../Components/CriticalTicketsTable.js";
import { Components_OpenTicketsTable_334C27A3 } from "../../Components/OpenTicketsTable.js";
import { Dashboard_OrdersTable_Z524259A4 } from "./OrdersTable.js";
import { Dashboard_ActivitiesTable_Z524259A4 } from "./ActivitiesTable.js";
import { Components_DeviationTicketsTable_334C27A3 } from "../../Components/DeviationTicketsTable.js";

export function View(viewInputProps) {
    let elems_4, elems_1, elems, elems_3, elems_2;
    const groupId = viewInputProps.groupId;
    const hierarchy = reactApi.useContext(hierarchyContext);
    const patternInput = reactApi.useState([]);
    const tickets = patternInput[0];
    const setTickets = patternInput[1];
    const patternInput_1 = partition((_arg) => _arg.CriticalOperationalHalt, tickets);
    const customerIds = choose((customer) => {
        if (customer.EnableExtra) {
            return customer.Id;
        }
        else {
            return undefined;
        }
    }, find((group) => (group.Id === groupId), hierarchy.Groups).Customers, Int32Array);
    useEffectWithDeps(() => {
        let properties_2;
        const url = "/api/tickets" + generateQueryString([["group", int32ToString(groupId)], ["closed", toString(true)], ["customers", join(",", map(int32ToString, customerIds))]]);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg_1) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                const tickets_1 = res.fields[0];
                console.info(some("Fetched tickets"), tickets_1.length);
                setTickets(tickets_1);
            }
            else {
                console.error(some("Error fetching tickets"), res.fields[0]);
            }
        });
        return createDisposable(() => {
            setTickets([]);
        });
    }, [groupId]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: 20 + "px",
    }], (elems_1 = [createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], ["style", {
        flexGrow: 1,
        flexBasis: 1080 + "px",
        overflow: "auto",
    }], (elems = [createElement(Components_CriticalTicketsTable_334C27A3, {
        tickets: patternInput_1[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: 20 + "px",
    }], (elems_3 = [createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], ["style", {
        flexGrow: 1,
        flexBasis: 600 + "px",
        overflow: "auto",
    }], (elems_2 = [createElement(Components_OpenTicketsTable_334C27A3, {
        tickets: patternInput_1[1],
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", {
        className: join(" ", ["bordered-container"]),
        style: {
            flexGrow: 1,
            flexBasis: 800 + "px",
            overflow: "auto",
        },
        children: createElement(Dashboard_OrdersTable_Z524259A4, {
            groupId: groupId,
        }),
    }), createElement("div", {
        className: join(" ", ["bordered-container"]),
        style: {
            flexGrow: 1,
            flexBasis: 800 + "px",
            overflow: "auto",
        },
        children: createElement(Dashboard_ActivitiesTable_Z524259A4, {
            groupId: groupId,
        }),
    }), createElement("div", {
        className: join(" ", ["bordered-container"]),
        style: {
            flexGrow: 1,
            flexBasis: 800 + "px",
            overflow: "auto",
        },
        children: createElement(Components_DeviationTicketsTable_334C27A3, {
            tickets: tickets,
        }),
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

